import {
  boolean,
  coerce,
  defaulted,
  mask,
  object,
  optional,
  string,
} from "superstruct";

function flag() {
  return coerce(boolean(), optional(string()), (v) => v === "true");
}

export const config = mask(
  import.meta.env,
  object({
    VITE_ENV: optional(string()),
    VITE_ITC_API_ORIGIN: defaulted(string(), "http://localhost:8000"),
    VITE_ENABLE_SENTRY: flag(),
  }),
);
